exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".outer_width{width: 900px;}\n.mat-select{margin-top: 11px;white-space: nowrap;}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/admin-edit-travel-info/admin-edit-travel-info.component.css
// module id = ../../../../../src/app/admin/admin-edit-travel-info/admin-edit-travel-info.component.css
// module chunks = 39